import { render, staticRenderFns } from "./prodcuto-tienda-online.vue?vue&type=template&id=7fe9dcdc&scoped=true&"
import script from "./prodcuto-tienda-online.vue?vue&type=script&lang=ts&"
export * from "./prodcuto-tienda-online.vue?vue&type=script&lang=ts&"
import style0 from "./prodcuto-tienda-online.vue?vue&type=style&index=0&id=7fe9dcdc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fe9dcdc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VContainer,VIcon,VImg,VRow})
